import React from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';

interface LimitMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onLimitChange: (limit: number) => void;
  currentLimit: number;
}

const LimitMenu: React.FC<LimitMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onLimitChange,
  currentLimit,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: 'white',
        },
      }}
    >
      <MenuItem disabled>
        <Typography variant="subtitle2">results per page</Typography>
      </MenuItem>
      {[5, 10, 20, 50, 80, 100].map((limit) => (
        <MenuItem
          key={limit}
          onClick={() => onLimitChange(limit)}
          selected={currentLimit === limit}
        >
          {limit}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default LimitMenu;
